import oymCookieConsent from '@onyourmarks/cookie-consent';
import type { ConfigType } from '@onyourmarks/cookie-consent/dist/types/_types/config';
import BaseModule from '$src/js/base/BaseModule';

const initCookieConsent = () => {
  const options: ConfigType = {
    consentOptions: [
      {
        key: 'marketing',
        title: 'Marketing',
        description: BaseModule.getInstance().i18n.translate(
          'cookie_consent_marketing_description',
        ),
      },
    ],
    consentMode: {
      ad_personalization: 'marketing',
      ad_storage: 'marketing',
      ad_user_data: 'marketing',
      analytics_storage: 'statistics',
    },
    cookieName: 'oymcc',
    exceptionUrls: [],
    explanationAnchors: [
      {
        title: BaseModule.getInstance().i18n.translate('cookie_consent_more_info'),
        href: BaseModule.getInstance().i18n.translate('cookie_consent_more_link'),
      },
    ],
    manageable: true,
    denyable: true,
    renderSelector: '[data-oymcc-render]',
    style: 'bar',
    language: document.documentElement.lang || 'en',
    version: '1.0',
  };

  oymCookieConsent.init(options);
};

export default initCookieConsent;
